import { maskCredentialValue } from './maskCredentials';

/** Channel types that use SupportWidget embed + widgetSecret credentials. */
const WIDGET_EMBED_CHANNEL_CODES = new Set(['GARAGES', 'FLOWWW']);

export function isWidgetEmbedChannelType(code: string | undefined): boolean {
  if (!code) return false;
  return WIDGET_EMBED_CHANNEL_CODES.has(code.toUpperCase());
}

/** Widget JWT `source` / ChannelConfig `identifier` for embed channels. */
export function suggestedWidgetIdentifier(channelTypeCode: string): string | null {
  switch (channelTypeCode.toUpperCase()) {
    case 'GARAGES':
      return 'GARAGES';
    case 'FLOWWW':
      return 'FLOWW';
    default:
      return null;
  }
}

export function generateWidgetSecret(): string {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function parseWidgetSecretFromCredentials(
  credentials: Record<string, unknown> | null | undefined,
): string | null {
  if (!credentials) return null;
  const value = credentials.widgetSecret;
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

export function maskWidgetSecret(secret: string): string {
  return String(maskCredentialValue(secret));
}

export function widgetCredentialsPayload(secret: string): Record<string, unknown> {
  return { widgetSecret: secret };
}
